import { Component, Input, OnInit } from '@angular/core';
import { Validators, ReactiveFormsModule, FormsModule } from '@angular/forms';
import { FilterDTO, FilterOperator, ParkingSubscriptionClient, ParkingSubscriptionDTO, ParkingSubscriptionType, SortDirection } from 'src/app/base/models/models.swagger.generated';
import { DropDownConstantsFactory, StandardDropdownItem } from 'src/app/base/shared/syncfusion/dropdown-constants-factory';
import { CustomValidatorsFactory } from 'src/app/base/shared/validators/custom-validators-factory';
import { EndSubscriptionFormGroup } from './parker-function-end-subscription-form.type';
import { TranslateModule } from '@ngx-translate/core';
import { DateTimePickerModule } from '@syncfusion/ej2-angular-calendars';
import { NgClass } from '@angular/common';
import { YesNoGroupButtonComponent } from '../../../../../base/shared/yes-no-group-button/yes-no-group-button.component';
import { AppErrorMessagesComponent } from '../../../../../base/error-messages/app-error-messages.component';
import { DropDownListModule } from '@syncfusion/ej2-angular-dropdowns';

@Component({
    selector: 'app-parker-function-end-subscription-form',
    templateUrl: './parker-function-end-subscription-form.component.html',
    styleUrls: ['./parker-function-end-subscription-form.component.scss'],
    imports: [ReactiveFormsModule, DropDownListModule, AppErrorMessagesComponent, YesNoGroupButtonComponent, FormsModule, NgClass, DateTimePickerModule, TranslateModule]
})
export class ParkerFunctionEndSubscriptionFormComponent implements OnInit {

  @Input() public parkerSubscriptionForm: EndSubscriptionFormGroup;
  @Input() public clientId: number;

  public dropdownSettings = DropDownConstantsFactory.createStandardClientDropdownSettings();
  public subscriptionsDropdownValues: StandardDropdownItem[] = [];
  public isToDateImmediate = false;
  public minDate = new Date();

  public allSubscriptions: ParkingSubscriptionDTO[] = [];
  constructor(private parkingSubscriptionClient: ParkingSubscriptionClient) {
  }

  ngOnInit() {
    this.isToDateImmediate = this.parkerSubscriptionForm.value.validTo === null;
    this.handleDateField(this.isToDateImmediate);

    const filters = [
      new FilterDTO({
        isComplex: false,
        field: 'Active',
        operator: FilterOperator.Equal,
        value: 'true'
      }),
      new FilterDTO({
        isComplex: false,
        field: 'Type',
        operator: FilterOperator.NotEqual,
        value: ParkingSubscriptionType.ForeignParkerSubscription.toString()
      })
    ];

    this.parkingSubscriptionClient.searchParkingSubscriptions(this.clientId, filters, 0, 0, 'Name', SortDirection.Ascending)
      .subscribe(res => {
        this.allSubscriptions = res.items;
        this.subscriptionsDropdownValues = res.items.map(s => {
          let label = s.name;
          if (s.description) {
            label += ', ' + s.description;
          }

          return {name: label, id: s.id};
        });
      });
  }

  public handleDateField(isDateImmediate: boolean): void {
    if (isDateImmediate) {
      this.parkerSubscriptionForm.controls.validTo.disable();
      this.parkerSubscriptionForm.controls.validTo.setValue(null, {emitEvent: false});
      this.parkerSubscriptionForm.controls.validTo.setValidators([]);
    } else {
      this.parkerSubscriptionForm.controls.validTo.enable();
      this.parkerSubscriptionForm.controls.validTo.setValidators([Validators.required, CustomValidatorsFactory.validateDateNotInPast()]);
    }

    this.parkerSubscriptionForm.controls.validTo.updateValueAndValidity();
  }
}
